<template>
  <div class="warning-card" :class="this.variant">
    <div style="display: flex !important;">
      <img class="mr-2" style="border-radius: 10px; max-width: 15px; max-height: 15px" :src="`/img/img.png`">
      <div class="row mr-2" style="width: 100%">
        <div class="col">
          <div class="row">
            <div class="col">
              <span class="font-weight-bold">{{ this.title }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              {{ this.body }}
            </div>
          </div>
          <div class="row footer-info mt-2" v-if="this.hasFooter">
            <div class="col">
              <div>
                <span><i class="sr sr-timer" style="color: grey"/> Цагийн хуваарь: </span>
                <span class="ml-2" style="color: grey">Даваа-Баасан</span> <span class="ml-1"> {{companyInfo.schedule}}</span>
              </div>
            </div>
            <div class="col">
              <span> <i class="sr sr-missedcall"  style="color: grey"/> Утас: </span>
              <span class="ml-2" style="color: grey">(+976) </span> <span class="ml-1">{{companyInfo.phone}}</span>
            </div>

            <div class="col">
              <span> <i class="sr sr-placemarker"  style="color: grey"/> Хаяг: </span>
              <span class="ml-2 text-right" style="color: grey">{{companyInfo.address}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {CompanyInfo} from '../utils/constants'
export default {
  props: {
    variant: {type: String, default: 'warning'},
    title: {type: String, default: 'Санамж'},
    body: {type: String, default: ''},
    hasFooter: {type: Boolean, default: false},
  },
  data() {
    return {
      companyInfo: CompanyInfo,
    }
  }
}
</script>
<style scoped lang="scss">
.warning-card {
  border-radius: 6px;
  border-color: grey;
  font-size: 12px;
  padding: 10px;
  color: var(--text-primary-color)
}
.warning-card.warning {
  border: 1px solid var(--ui-secondary);
  background-color: #F0B4001A;
}
.warning-card.success {
  border: 1px solid darkgreen;
}
.warning-card.error {
  border: 1px solid red;
}

.footer-info{
  border-top: 1px solid #F0B400;
  padding-top: 5px;
}
</style>